import { render, staticRenderFns } from "./cookieTip.vue?vue&type=template&id=b1d38ab8&scoped=true&"
import script from "./cookieTip.vue?vue&type=script&lang=js&"
export * from "./cookieTip.vue?vue&type=script&lang=js&"
import style0 from "./cookieTip.vue?vue&type=style&index=0&id=b1d38ab8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d38ab8",
  null
  
)

export default component.exports